import BaseModel from "./BaseModel";
import ImageCollectionCategory from "./Enums/ImageCollectionCategory";
import ImageCollectionVisibility from "./Enums/ImageCollectionVisibility";

class ImageCollection extends BaseModel {
	constructor(data) {
		super({}, ImageCollection.defaults);
		this.data = data;
		this.images = [];
	}

	isNew() {
		return typeof this.id === "undefined" || this.id === -1;
	}

	get id() {
		return this.get("id");
	}

	get name() {
		return this.get("name");
	}

	get category() {
		return this.get("category");
	}

	get imageIds() {
		return this.get("image_ids");
	}

	get imageCount() {
		return this.get("image_count");
	}

	get visibility() {
		return this.get("visibility");
	}

	get companyIds() {
		const ids = [];
		const acl = this.get("acl");
		for (let i = 0; i < acl.length; i++) {
			if (acl[i].type === "company") {
				ids.push(acl[i].id);
			}
		}
		return ids;
	}

	get ownerCompanyId() {
		return this.get("owner_company_id");
	}

	get ownerCompanyName() {
		return this.get("owner_company_name");
	}

	update(data) {
		super.setData(data);
	}
}
ImageCollection.defaults = { // Defaults
	id: -1,
	name: "",
	category: ImageCollectionCategory.GENERAL,
	image_count: 0,
	image_ids: [],
	owner_company_id: 0,
	owner_company_name: "",
	visibility: ImageCollectionVisibility.INTERNAL,
	acl: []
};

export default ImageCollection;
